
import { Box, Button, Paper, TextField } from "@mui/material";
import React from "react";

const BottleFooter = ({ newQuestion, setNewQuestion, myPrivileges, handleAddQuestion, handleResetRoom, roomCode }) => {
    return (
        <Box sx={{ mt: 5, px: 2 }}>
            <Paper
                sx={{
                    p: 2,
                    mb: 2,
                    display: "flex",
                    gap: 1,
                    borderRadius: 3,
                    alignItems: "center",
                }}
            >
                <TextField
                    size="small"
                    fullWidth
                    placeholder="เพิ่มคำถามลง Pool..."
                    value={newQuestion}
                    disabled={!myPrivileges || myPrivileges.addQ <= 0}
                    onChange={(e) => setNewQuestion(e.target.value)}
                    variant="standard"
                />
                <Button
                    variant="contained"
                    disabled={!myPrivileges || myPrivileges.addQ <= 0}
                    onClick={handleAddQuestion}
                    sx={{ borderRadius: 2 }}
                >
                    เพิ่ม ({myPrivileges?.addQ || 0})
                </Button>
            </Paper>
            <Button
                variant="contained"
                color="error"
                fullWidth
                onClick={() => window.confirm("ล้างข้อมูลทั้งหมด?") && handleResetRoom()}
            >
                RESET ROOM
            </Button>
        </Box>
    );
};

export default BottleFooter;
